export default hashid => (
  window.open(`${process.env.API_LOCATION}/credit_note/${hashid}/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/creditNote/show.js